import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  ImaxxActions,
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { mapTreatmentPlanBenefit } from "./maps";
import { TreatmentPlanBenefit } from "./treatment-plan-benefit";

export const featureKey = "treatmentPlanBenefits";

export type State = EntityState<TreatmentPlanBenefit>;

export const adapter = createEntityAdapter<TreatmentPlanBenefit>({
  selectId: (benefit: TreatmentPlanBenefit) => benefit.id,
  sortComparer: false,
});

export const initialState: State = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(TreatmentPlanApiActions.loadBenefitSuccess, (state, { benefits }) =>
    adapter.setAll(
      benefits.map((b) => mapTreatmentPlanBenefit(b)),
      state
    )
  ),
  on(TreatmentPageActions.treatmentPlanRemoved, (state, { id }) =>
    adapter.removeMany(
      Object.keys(state.entities).filter(
        (k) => state.entities[k].treatmentPlanId === id
      ),
      state
    )
  ),
  on(TreatmentPlanApiActions.calculateSuccess, (state, { benefit }) =>
    adapter.upsertOne(mapTreatmentPlanBenefit(benefit), state)
  ),
  on(
    ImaxxActions.updateImaxxOptimizerSuccess,
    (state, { TreatmentPlanBenefit }) => {
      if (TreatmentPlanBenefit) {
        return adapter.upsertOne(
          mapTreatmentPlanBenefit(TreatmentPlanBenefit),
          state
        );
      } else {
        return state;
      }
    }
  ),
  on(
    TreatmentPageActions.networkDiscountUpdated,
    (state, { treatmentPlanBenefitId, networkDiscount }) =>
      adapter.updateOne(
        {
          id: treatmentPlanBenefitId,
          changes: {
            networkDiscount,
          },
        },
        state
      )
  )
);
